import Grid from "@mui/material/Grid2";

import { Check, CheckCircleOutline } from "@mui/icons-material";

import "./payment.scss";
import { Box, Button, Typography } from "@mui/material";

interface SubscriptionAddOnCard {
  product: any;
  type: number;
  setAddCheck: any;
  addCheck: boolean;
}

const SubscriptionAddOnCard: React.FC<SubscriptionAddOnCard> = ({
  product,
  type,
  setAddCheck,
  addCheck,
}) => {
  return (
    <>
      {product && (
        <>
          <Grid size={{ xs: 12, md: 6, lg: 3 }} mt={10}>
            <div className="planMainCard">
              <div className="planMainCard__body">
                <div className="planMainCard__heading">
                  {type === 0 ? (
                    <>
                      <Typography
                        variant="h5"
                        fontWeight={"550"}
                        marginBottom={"10px"}
                      >
                        Mailbox Integration
                      </Typography>
                      <Typography className="planMainCard__price">
                        <strong>${product.price}</strong> / seat (mo)
                      </Typography>
                    </>
                  ) : type === 1 ? (
                    <>
                      <Typography
                        variant="h5"
                        fontWeight={"550"}
                        marginBottom={"10px"}
                      >
                        SMS Integration
                      </Typography>
                      {/* <Typography className="planMainCard__price">
                        <strong>${product.price}</strong> / mo
                      </Typography> */}
                    </>
                  ) : (
                    <>
                      <Typography
                        variant="h5"
                        fontWeight={"550"}
                        marginBottom={"10px"}
                      >
                        Scheduling
                      </Typography>
                      <Typography className="planMainCard__price">
                        <strong>${product.price}</strong> / mo
                      </Typography>
                    </>
                  )}
                </div>
                <ul className="planMainCard__list">
                  {product.features.map((feature: any, index: number) => {
                    return (
                      <li className="planMainCard__list-item" key={index}>
                        <CheckCircleOutline
                          sx={{ color: "#096dd9", backgroundColor: "white" }}
                        />
                        <div>{feature}</div>
                      </li>
                    );
                  })}
                </ul>
              </div>
              <Box sx={{ textAlign: "center", marginTop: "20px" }}>
                <Button
                  sx={{
                    padding: addCheck ? "8px 35px" : "8px 24px",
                    color: addCheck ? "black" : "#096dd9",
                    border: addCheck ? "2px solid black" : "2px solid #096dd9",
                    borderRadius: "4px",
                    textAlign: "center",
                  }}
                  onClick={() =>
                    setAddCheck((prevState: boolean) => !prevState)
                  }
                >
                  {addCheck ? "Remove" : "Add to Plan"}
                </Button>
              </Box>
            </div>
          </Grid>
        </>
      )}
    </>
  );
};

export default SubscriptionAddOnCard;
